var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHotIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1821_8959)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M219 5.52526C211.2 -1.77474 199.1 -1.87474 191.3 5.42526C144.7 48.6253 105.3 97.7253 77.4 144.825C49.8 191.225 32 238.125 32 276.525C32 404.125 130.4 512.025 256 512.025C380.2 512.025 480 404.225 480 276.625C480 247.225 466.5 205.525 446.2 164.725C425.6 123.325 396.3 79.7253 361.7 46.7253C353.8 39.2253 341.6 39.2253 333.7 46.6253C320.2 59.4253 307.7 75.1253 296.7 89.5253C272.5 59.3253 246.6 31.4253 219 5.52526Z",
    fill: "#FFD15B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.45 5.42526C201.25 -1.87474 213.35 -1.77474 221.15 5.52526C248.75 31.4253 274.65 59.3253 298.85 89.5253C309.85 75.1253 322.35 59.4253 335.85 46.6253C343.75 39.2253 355.95 39.2253 363.85 46.7253C398.45 79.7253 427.75 123.325 448.35 164.725C468.65 205.525 482.15 247.225 482.15 276.625C482.15 404.225 382.35 512.025 258.15 512.025C132.55 512.025 34.1504 404.125 34.1504 276.525C34.1504 238.125 51.9504 191.225 79.5504 144.825C107.45 97.7253 146.85 48.6253 193.45 5.42526ZM259.85 416.025C285.15 416.025 307.55 409.025 328.65 395.025C370.75 365.625 382.05 306.825 356.75 260.625C353.95 255.025 351.15 249.425 346.95 243.825L296.35 302.625C296.35 302.625 214.95 199.025 209.25 192.025C167.25 243.825 146.15 273.225 146.15 306.825C146.15 375.425 196.75 416.025 259.85 416.025Z",
    fill: "#FF3D00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1821_8959"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHotIcon);
export default __webpack_public_path__ + "static/media/hot-icon.cc39375fa93a8ffc10f69cd583fefc8e.svg";
export { ForwardRef as ReactComponent };